import { Box, lighten } from '@mui/material';
import { OfflineBolt } from '@mui/icons-material';

import { Typography } from '@occc-app/design-system';

export const SweepstakesFormContent = () => (
  <Box
    data-testid='sweepstakes-form'
    p={3}
    bgcolor={({ palette }) => lighten(palette.primary.main, 0.9)}
    borderRadius={2}
  >
    <Typography variant='h6' component='h4' paragraph display='flex'>
      <OfflineBolt color='primary' sx={{ mr: 1 }} />
      How Sweepstakes Work
    </Typography>
    <Typography>
      Sweepstakes entries are configured here and can then be used as the award of an Offer or
      Reward. Running a sweepstakes program requires tight coordination with your web or mobile app
      experience.
    </Typography>
  </Box>
);
